var _defs, _rect, _text, _text2, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPlatformLoop(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 1400,
    height: 800,
    viewBox: "0 0 1400 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "gGreen",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#4CAF50"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#2E7D32"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gBlue",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#2196F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1565C0"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "gOrange",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 1
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#FFC107"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#FF6F00"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "shadow",
    x: "-20%",
    y: "-20%",
    width: "140%",
    height: "140%"
  }, /*#__PURE__*/React.createElement("feDropShadow", {
    dx: 0,
    dy: 10,
    stdDeviation: 12,
    floodColor: "#0B1220",
    floodOpacity: 0.12
  })), /*#__PURE__*/React.createElement("marker", {
    id: "arrow",
    viewBox: "0 0 10 10",
    refX: 8,
    refY: 5,
    markerWidth: 8,
    markerHeight: 8,
    orient: "auto-start-reverse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0 0 L 10 5 L 0 10 z",
    fill: "#334155"
  })), /*#__PURE__*/React.createElement("style", null, "\r\n      .bg { fill: #F8FAFC; }\r\n      .card { fill: #FFFFFF; stroke: rgba(15,23,42,0.08); filter: url(#shadow); }\r\n      .title { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 800; }\r\n      .label { fill: #1A202C; font-family: Inter, Roboto, Arial, sans-serif; font-weight: 700; }\r\n      .muted { fill: #4A5568; font-family: Inter, Roboto, Arial, sans-serif; }\r\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "bg",
    width: 1400,
    height: 800
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    className: "title",
    x: 80,
    y: 95,
    fontSize: 34
  }, "Carbon Intelligence \xB7 Data \xB7 Action \xB7 Finance Loop")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 80,
    y: 130,
    fontSize: 16
  }, "This is the core \"why it works\" flywheel for MSMEs and banks.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(80,180)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "card",
    x: 0,
    y: 0,
    width: 1240,
    height: 560,
    rx: 24
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(120,120)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 130,
    rx: 22,
    fill: "rgba(33,150,243,0.06)",
    stroke: "rgba(33,150,243,0.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 42,
    fontSize: 18
  }, "1) Capture data"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 72,
    fontSize: 14
  }, "Bills, invoices, activity inputs"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 14
  }, "Auto-extraction + dedup")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,70)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 130,
    rx: 22,
    fill: "rgba(76,175,80,0.06)",
    stroke: "rgba(76,175,80,0.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 42,
    fontSize: 18
  }, "2) Compute carbon"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 72,
    fontSize: 14
  }, "Total CO\u2082 + category split"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 14
  }, "ESG Scopes 1/2/3 + score")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(920,220)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 280,
    height: 130,
    rx: 22,
    fill: "rgba(255,193,7,0.14)",
    stroke: "rgba(255,111,0,0.25)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 42,
    fontSize: 18
  }, "3) Take action"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 72,
    fontSize: 14
  }, "Recommendations"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 14
  }, "Savings + payback")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,360)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 130,
    rx: 22,
    fill: "rgba(33,150,243,0.06)",
    stroke: "rgba(33,150,243,0.22)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 22,
    y: 42,
    fontSize: 18
  }, "4) Prove it"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 72,
    fontSize: 14
  }, "Reports, exports, audit trail"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 22,
    y: 96,
    fontSize: 14
  }, "Customer / regulator ready")), /*#__PURE__*/React.createElement("g", {
    transform: "translate(150,330)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 320,
    height: 150,
    rx: 22,
    fill: "url(#gGreen)",
    opacity: 0.98
  }), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 50,
    fontSize: 18,
    fill: "#FFFFFF",
    fontFamily: "Inter, Roboto, Arial, sans-serif",
    fontWeight: 800
  }, "5) Unlock finance"), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 82,
    fontSize: 14,
    fill: "#E8F5E8",
    fontFamily: "Inter, Roboto, Arial, sans-serif"
  }, "Green loan eligibility"), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 106,
    fontSize: 14,
    fill: "#E8F5E8",
    fontFamily: "Inter, Roboto, Arial, sans-serif"
  }, "Better pricing via score"), /*#__PURE__*/React.createElement("text", {
    x: 22,
    y: 130,
    fontSize: 14,
    fill: "#E8F5E8",
    fontFamily: "Inter, Roboto, Arial, sans-serif"
  }, "Portfolio insights for banks")), /*#__PURE__*/React.createElement("path", {
    d: "M460 185 C520 170, 520 170, 520 170",
    stroke: "#334155",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M880 200 C950 210, 950 220, 920 250",
    stroke: "#334155",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1060 350 C980 400, 940 430, 880 430",
    stroke: "#334155",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M520 470 C420 500, 360 500, 310 480",
    stroke: "#334155",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M280 330 C240 290, 240 250, 270 230",
    stroke: "#334155",
    strokeWidth: 3,
    fill: "none",
    markerEnd: "url(#arrow)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(520,230)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 360,
    height: 110,
    rx: 18,
    fill: "#FFFFFF",
    stroke: "rgba(148,163,184,0.35)"
  }), /*#__PURE__*/React.createElement("text", {
    className: "label",
    x: 18,
    y: 36,
    fontSize: 14
  }, "Flywheel effect"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 60,
    fontSize: 13
  }, "More usage \x92 better data \x92 better guidance"), /*#__PURE__*/React.createElement("text", {
    className: "muted",
    x: 18,
    y: 82,
    fontSize: 13
  }, "\x92 better outcomes \x92 more finance access")))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlatformLoop);
export default __webpack_public_path__ + "static/media/platform-loop.f3fc56e41e2f9e8d9c8696f0f3493817.svg";
export { ForwardRef as ReactComponent };